import { OrganizationRoleType } from "../../autogen/bff-api";

export const canViewProjects = (roles: OrganizationRoleType[]) =>
  roles.some((r) => r === "Owner" || r === "Admin" || r === "ProjectCreator" || r === "ProjectViewer");
